import { useRecoilState } from 'recoil'

import { freqState } from '../recoil/atoms/appAtom'

export const useRecoilFreq = () => {
  const [freq, setFreq] = useRecoilState(freqState)
  const volume = freq.reduce((acc, cur) => acc + cur, 0) / freq.length || 0
  return {
    freq: freq,
    setFreq: setFreq,
    volume: volume,
  }
}
